import React from 'react';
import Box from '@mui/material/Box';

function CardHeader({ children, sx, ...rest }) {
  return (
    <Box
      sx={{
        width: '100%',
        mb: 2,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}

export default CardHeader;
